module.exports = __webpack_public_path__ + "static/img/indexPic9.0a30053.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/indexPic9.png
// module id = XuAT
// module chunks = 1